import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconAutomatic } from '../../../../../../assets/icons/icon-automatic';
import { BlindFeatureTypeInternal } from '../../../../../../data-access/gql-types/graphql';
import { ChannelCoverType, ChannelType } from '../../../../types';
import { Calibration } from '../../../device-settings/device-settings-form/sections/calibration';
import { BlindManualCalibrationDialog } from './manual-calibration-dialog';

type BlindCalibrationProps = {
  channel: ChannelType;
};

export const BlindCalibration: React.FC<BlindCalibrationProps> = ({ channel }) => {
  const { t } = useTranslation('channel-settings');
  const [showManualDialog, setShowManualDialog] = useState<boolean>(false);
  const supportedFeatures = (channel.data as ChannelCoverType).supportedBlindFeatures;
  const manualCalibration = supportedFeatures.includes(BlindFeatureTypeInternal.ManualCalibration);

  return manualCalibration ? (
    <>
      <div className="max-width-desktop">
        <button onClick={() => setShowManualDialog(true)} className="button button--secondary button--active-on-click">
          <IconAutomatic />
          {t('manual')}
        </button>
      </div>
      <BlindManualCalibrationDialog
        channel={channel}
        showManualDialog={showManualDialog}
        setShowManualDialog={setShowManualDialog}
      />
    </>
  ) : (
    <Calibration channel={channel} />
  );
};
